import {
  generateUuid,
  isValidUuid,
} from '../../../website/static/js/services/utils';
import { storage } from '../../../website/static/js/services/storage';
import { PERSISTENT_STORAGE_IDENTIFIER_KEY } from '../../../website/static/js/application/lib/constants';

export const identifyTrackingUserId = () => {
  let userIdentifier = storage.get(PERSISTENT_STORAGE_IDENTIFIER_KEY);

  if (!isValidUuid(userIdentifier)) {
    userIdentifier = generateUuid();

    storage.set(PERSISTENT_STORAGE_IDENTIFIER_KEY, userIdentifier);
  }

  console.info('persistentStorage: identified user:', userIdentifier);
};

export const getTrackingUserId = () =>
  storage.get(PERSISTENT_STORAGE_IDENTIFIER_KEY);
